import Layout from '@/layout';
var qualificationRouter = {
  path: '/qualification',
  component: Layout,
  redirect: '/qualification/list',
  name: 'Qualification',
  alwaysShow: true,
  meta: {
    title: '资质认证',
    icon: 's-check'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/qualification/list');
    },
    name: 'QualificationList',
    meta: {
      title: '认证申请'
    }
  }, {
    path: 'type',
    component: function component() {
      return import('@/views/qualification/type');
    },
    name: 'QualificationType',
    meta: {
      title: '认证类型'
    }
  }]
};
export default qualificationRouter;